import React from 'react';

/** Minimal shimmer placeholder – use instead of "Načítavam..." / Spin */
export const Skel = ({ width = '100%', height = 12, style, className = '' }) => (
  <span
    className={`skel ${className}`.trim()}
    style={{ width, height, ...style }}
    aria-hidden
  />
);

export const SkelLines = ({ count = 5, gap = 8 }) => (
  <div className="skel-stack" style={{ gap }} aria-busy="true" aria-label="Načítava sa">
    {Array.from({ length: count }, (_, i) => (
      <Skel
        key={i}
        height={i % 3 === 0 ? 14 : 11}
        width={i % 4 === 0 ? '72%' : i % 3 === 1 ? '88%' : '100%'}
      />
    ))}
  </div>
);

export const SkelCards = ({ count = 4 }) => (
  <div className="skel-cards" aria-busy="true">
    {Array.from({ length: count }, (_, i) => (
      <div key={i} className="skel-card">
        <Skel height={22} width="40%" />
        <Skel height={10} width="70%" style={{ marginTop: 8 }} />
      </div>
    ))}
  </div>
);

export const SkelTable = ({ rows = 6, cols = 4 }) => (
  <div className="skel-table" aria-busy="true">
    <div className="skel-table-head">
      {Array.from({ length: cols }, (_, i) => (
        <Skel key={i} height={10} width={`${60 + (i % 3) * 10}%`} />
      ))}
    </div>
    {Array.from({ length: rows }, (_, r) => (
      <div key={r} className="skel-table-row">
        {Array.from({ length: cols }, (_, c) => (
          <Skel key={c} height={11} width={c === 1 ? '90%' : '55%'} />
        ))}
      </div>
    ))}
  </div>
);

export const SkelList = ({ rows = 8 }) => (
  <div className="skel-list" aria-busy="true">
    {Array.from({ length: rows }, (_, i) => (
      <div key={i} className="skel-list-row">
        <Skel height={10} width={28} />
        <Skel height={11} width={72} />
        <Skel height={11} width="100%" style={{ flex: 1 }} />
        <Skel height={11} width={48} />
      </div>
    ))}
  </div>
);

/** Sidebar recent-items list (niceid + date + title) */
export const SkelRecent = ({ rows = 6 }) => (
  <div className="skel-recent" aria-busy="true" aria-label="Načítava sa">
    {Array.from({ length: rows }, (_, i) => (
      <div key={i} className="skel-recent-item">
        <div className="skel-recent-top">
          <Skel height={10} width={56} />
          <Skel height={9} width={42} />
        </div>
        <Skel height={11} width={i % 2 === 0 ? '92%' : '78%'} />
        <Skel height={9} width={i % 3 === 0 ? '38%' : '52%'} style={{ marginTop: 4 }} />
      </div>
    ))}
  </div>
);

/** Stats card: donut + tiles + activity bars */
export const SkelStats = () => (
  <div className="skel-stats" aria-busy="true" aria-label="Načítava sa">
    <div className="skel-stats-donut-row">
      <Skel className="skel-stats-donut" width={118} height={118} style={{ borderRadius: '50%' }} />
      <div className="skel-stats-tiles">
        {Array.from({ length: 4 }, (_, i) => (
          <div key={i} className="skel-stats-tile">
            <Skel height={9} width="55%" />
            <Skel height={14} width={28} />
          </div>
        ))}
      </div>
    </div>
    <div className="skel-stats-bars">
      <div className="skel-stats-bars-head">
        <Skel height={10} width={120} />
        <Skel height={10} width={36} />
      </div>
      <div className="skel-stats-bars-chart">
        {Array.from({ length: 12 }, (_, i) => (
          <div key={i} className="skel-stats-bar-col">
            <Skel height={20 + (i % 5) * 12} width={8} style={{ borderRadius: 2 }} />
            <Skel height={18 + ((i + 2) % 4) * 10} width={8} style={{ borderRadius: 2 }} />
          </div>
        ))}
      </div>
    </div>
  </div>
);

/** Wrap loaded content for a soft fade-in */
export const FadeIn = ({ children, className = '' }) => (
  <div className={className ? className : 'fade-in'}>{children}</div>
);

export default Skel;
